/* eslint-disable */
"use strict";
import configurazioni from "@/services/configurazioniService.js";
import { fetchTO } from "@/components/helpers";
// const service = process.env.VUE_APP_service_prodotti || '' // usato solo per installazione su Windows 32bit (senza IIS con reverse proxy)
var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_prodotti || process.env.VUE_APP_service_prodotti;
})();

let bearerToken = "";

const LRU = require("lru-cache");
const options = { max: 500, maxAge: 1000 * 60 * 60 };
const cache = new LRU(options);

/* const NodeCache = require('node-cache')
const prodottiPreCache = new NodeCache()
let popolaPreCacheInCorso = false */

function setToken(key) {
  bearerToken = key;
}

async function cicleSync(multiplo) {
  if (cache) {
    cache.reset();
  }
  // prodottiPreCache.flushAll()
  try {
    const response = await fetch(`${service}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    // setTimeout(async () => await popolaPreCache(), 500)
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  try {
    const response = await fetchTO(`${service}/mode`);
    return await response.json();
  } catch {
    return {
      modulo: "PRODOTTI",
      locale: "---",
      remote: "---",
      versione: "---",
      health: "---",
    };
  }
}

// NON USATA -->
/* async function popolaPreCache(flush) {
  if (popolaPreCacheInCorso) return
  popolaPreCacheInCorso = true
  console.log('popolaPreCache')
  if (flush) {
    prodottiPreCache.flushAll()
  }
  if (prodottiPreCache.getStats().keys === 0) {
    const elenco = await getAllProducts()
    prodottiPreCache.mset(elenco.rows.map(r => {
      return {
        key: String(r.id),
        val: r.doc
      }
    }))
  }
  popolaPreCacheInCorso = false
} */

async function getAllProducts() {
  const response = await fetch(`${service}/prodotti`);
  return await response.json();
}

async function getFilteredProducts(filtri, opzioni, versione) {
  const data = {
    filtri,
    opzioni,
  };
  try {
    /* eslint-disable */
    const response = await fetch(
      `${service}/${versione ? versione + "/" : ""}filter`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getProdottiByIds(ids) {
  try {
    const response = await fetch(`${service}/ids`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ids),
    });
    const result = await response.json();
    return result.rows
      .filter((x) => !x.error && !x.value.deleted)
      .map((x) => x.doc);
  } catch (error) {
    // winston.error(`getProdottiByIds: ${error}`);
    console.log(error);
    return [];
  }
}

// NON FUNZIONA !!
/* async function getCachedProdottiCategoria(model, value) {
  const prodotti = prodottiPreCache.mget(prodottiPreCache.keys())
  return prodotti.filter(x => _.get(x, model) === value)
}
 */
async function getModello(tipo) {
  const response = await fetch(`${service}/modello`);
  return await response.json();
}

async function getProdotto(codice) {
  const response = await fetch(`${service}/${codice}`);
  return await response.json();
}

async function searchProdotti(searchText) {
  // prevedere token
  const response = await fetch(`${service}/search?flt=${searchText}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + bearerToken,
    },
  });

  // const response = await fetch(`${service}/search?flt=${searchText}`)
  return await response.json();
}

async function searchProdottiTC(searchText) {
  const response = await fetch(`${service}/search/tc?flt=${searchText}`);
  return await response.json();
}

// Ritorna il documento completo del prodotto
async function getDettaglioProdotto(code) {
  const response = await fetch(`${service}/${code}`);
  return await response.json();
}

async function creaProdotto(prodotto) {
  const response = await fetch(`${service}/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(prodotto),
  });
  return await response.json();
}

async function aggiornaProdotto(prodotto) {
  const id = encodeURIComponent(prodotto.codice);
  const response = await fetch(`${service}/${id}/update`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(prodotto),
  });
  return await response.json();
}

// Ritorna solo alcuni campi del documento utili per la visualizzazione
async function getInfoProdotto(
  code,
  listino,
  variante,
  cliente,
  aliquota,
  barcode,
  cercaDisattivati
) {
  const data = {
    code,
    listino,
    variante: variante || "",
    cliente: cliente || "",
    aliquota,
    barcode, // opzionale, se presente in alternativa al codice prodotto
    cercaDisattivati,
  };
  const searchText = JSON.stringify(data);
  const cachedValue = cache.get(searchText);
  if (cachedValue) {
    return cachedValue;
  }
  const url = `${service}/info/scontrino`;

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ data }),
  });
  const result = await response.json();
  cache.set(searchText, result);

  return result;
}

async function getServizi(searchText) {
  let url = `${service}/servizi`;
  if (searchText) {
    url += `?flt=${searchText}`;
  }
  const response = await fetch(url);
  return await response.json();
}

async function getInfoFromBarcode(barcode) {
  console.log("prodotti--> getInfoFromBarcode");
  // const response = await fetch(`${service}/barcode/${barcode}`)
  const response = await fetch(`${service}/barcode/index/${barcode}`);
  return await response.json();
}

async function getListBarcode(barcode) {
  const response = await fetch(`${service}/barcode/list/${barcode}`);
  return await response.json();
}

async function creaProdottoTestBarcode(barcode, prodotto, nomeImport) {
  delete prodotto.barcode;
  var data = {
    barcode,
    codice: prodotto.codice,
    nomeImport,
    prodotto,
  };
  const response = await fetch(`${service}/create/barcode`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function creaProdottiMultipliTestBarcode(
  prodotti,
  nomeImport,
  usaTagliaColore,
  skipEsistente
) {
  var data = {
    prodotti,
    nomeImport,
    usaTagliaColore,
    skipEsistente,
  };
  const response = await fetch(`${service}/multipli/create/barcode`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return await response.json();
}

async function creaBarcodeProdotto() {
  var barcode = await configurazioni.getBarcodeInfo("prodotto");
  const data = {
    prefisso: `${barcode.prefissoInterno}`, // TODO: verificare, prefissoInterno viene utilizzato per generare manualemnte i codici
    ultimoNumero: barcode.ultimoNumero,
    tipo: barcode.tipoCodice,
  };
  const response = await fetch(`${service}/barcode/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const barcodeCreato = await response.json();
  await configurazioni.setBarcodeInfo(
    "prodotto",
    "write",
    barcodeCreato.ultimoNumero
  );
  return barcodeCreato;
}

async function estraeCategorie(nomeCampoSorgente) {
  try {
    const data = {
      nomeCampoSorgente,
    };
    const response = await fetch(`${service}/categorie`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(`estraeCategorie: ${error}`);
    return error;
  }
}

async function aggiornaGiacenzaMultipla(parametri, prodotti, usaTagliaColore) {
  try {
    const data = {
      parametri,
      prodotti,
      usaTagliaColore,
    };
    const response = await fetch(`${service}/multipli/giacenza`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.log(`aggiornaGiacenzaMultipla: ${error}`);
  }
  return false;
}

async function getProdottiEcommerce(isECommerce, idSku) {
  let url = `${service}/ecommerce?ec=${isECommerce ? "true" : "false"}`;
  if (idSku) {
    url += `&sku=${idSku}`;
  }
  const response = await fetch(url);
  const elenco = await response.json();
  return elenco.docs || [];
}

async function getProdottoEcommerce(isECommerce, idSku) {
  let url = `${service}/ecommerce?ec=${isECommerce ? "true" : "false"}`;
  if (idSku) {
    url += `&sku=${idSku}`;
  }
  const response = await fetch(url);
  const elenco = await response.json();
  if (elenco.docs.length === 1) {
    return elenco.docs[0];
  } else {
    return "";
  }
}

export default {
  setToken,
  cicleSync,
  getRunMode,
  getAllProducts,
  getFilteredProducts,
  getProdottiByIds,
  // getCachedProdottiCategoria,
  getModello,
  getProdotto,
  searchProdotti,
  searchProdottiTC,
  getServizi,
  creaProdotto,
  aggiornaProdotto,
  creaProdottoTestBarcode,
  getInfoProdotto,
  getDettaglioProdotto,
  getInfoFromBarcode,
  getListBarcode,
  creaBarcodeProdotto,
  creaProdottiMultipliTestBarcode,
  estraeCategorie,
  aggiornaGiacenzaMultipla,
  getProdottiEcommerce,
  getProdottoEcommerce,
};
